import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledFolderHeader = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 16px;
    font-size: var(--size-18);
    font-style: normal;
    font-weight: var(--weight-600);
    line-height: 25px;
    color: var(--color-primary);
    text-transform: uppercase;
    border-radius: var(--radius-5);
`;

export const StyledFolderContainer = styled.div`
    display: inline-grid;
    grid-gap: 25px;
    grid-template-columns: auto auto auto;
    @media ${breakpoints.xs} {
        grid-gap: 15px;
    }
`;
